<template>
  <div id="topnav">
    <nav class="nav">
      <ul class="logo-container">
        <li class="logo">
          <img
            src="../assets/img/navbarlogo.png"
            alt="sponsor a mum charity logo"
            class="logo-img"
          />
        </li>
      </ul>
      <ul class="link-container">
        <li class="links" @click="gotoSection('about-us')">
          About us
        </li>
        <li class="links" @click="gotoSection('contact')">
          Contact
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  methods: {
    gotoSection(section) {
      this.$emit("clicked", section);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/topnav.scss";
</style>
